export const REPORT_TRANSACTION_TYPES_LOADING =
  'REPORT_TRANSACTION_TYPES_LOADING';
export const REPORT_TRANSACTION_TYPES = 'REPORT_TRANSACTION_TYPES';
export const REPORT_TRANSACTION_TYPES_LOADING_ERROR =
  'REPORT_TRANSACTION_TYPES_LOADING_ERROR';

export const PRINT_REPORT_LOADING = 'PRINT_REPORT_LOADING';
export const PRINT_REPORT_ERROR = 'PRINT_REPORT_ERROR';
export const CLEAR_PRINT_REPORT_ERROR = 'CLEAR_PRINT_REPORT_ERROR';
export const RESET_PRINT_RESPONSE = 'RESET_PRINT_RESPONSE';
export const PRINT_REPORT_DATA = 'PRINT_REPORT_DATA';
export const SET_PRINT_RESPONSE_EMPTY = 'SET_PRINT_RESPONSE_EMPTY';



// WEBPACK FOOTER //
// ./src/pages/reports/inventory/commonState/types.js